import { render } from "./Messages.view.vue?vue&type=template&id=1a9c0af9"
import script from "./Messages.view.vue?vue&type=script&lang=js"
export * from "./Messages.view.vue?vue&type=script&lang=js"

import "./Messages.view.vue?vue&type=style&index=0&id=1a9c0af9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__